
define('text!ui/template/collection.html',[],function () { return '<each args="data: elems, as: \'element\'"><render if="hasTemplate()"></render></each>';});

